import { create } from "zustand";

export const bundleFilter = create((set) => ({
  currentFilter: null,
  filters: [],
  switchFilters: (filter) => set({ currentFilter: filter }),
  setFilters: (filters) => set({ filters }),
  clearFilters: () => set({ currentFilter: null }),
}));
